export function preventClickjack() {
  if (window.self === window.top) {
    var antiClickjack = document.getElementById('antiClickjack');

    if (typeof antiClickjack !== 'undefined' && antiClickjack) {
      antiClickjack.parentNode.removeChild(antiClickjack);
    }
  } else {
    window.top.location = window.self.location;
  }
}